export default function ActionBtn({ icon, label, color, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`${color} text-white p-6 rounded-3xl flex flex-col items-center justify-center gap-3 shadow-xl hover:-translate-y-1 active:scale-95 transition-all duration-300 group`}
    >
      <div className="group-hover:scale-110 transition-transform">{icon}</div>
      <span className="text-[11px] font-black uppercase tracking-[0.15em] text-center">
        {label}
      </span>
    </button>
  );
}